export default __webpack_public_path__ + "static/18-f0b8337849f818c53045104bb713102f.jpg";